"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**Convierte un Blob a una cadena base64 */
function blobToBase64(archivo) {
    return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onload = function () {
            var dataUrl = reader.result;
            //Caso especial, si el blob viene vacio esto devuelve "data:"
            if (dataUrl == "data:")
                resolve("");
            var base64Prefix = "base64,";
            var base64 = dataUrl.substring(dataUrl.indexOf(base64Prefix) + base64Prefix.length);
            resolve(base64);
        };
        reader.readAsDataURL(archivo);
    });
}
exports.blobToBase64 = blobToBase64;
/**Decodifica una cadena a base64 */
function base64ToString(base64) {
    return atob(base64);
}
exports.base64ToString = base64ToString;
/**Codifica una cadena a base64 */
function stringToBase64(str) {
    return btoa(str);
}
exports.stringToBase64 = stringToBase64;
/**Convierte una cadena base64 a un blob */
function base64ToBlob(base64, contentType) {
    //Este codigo fue tomado de
    //http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript#16245768
    contentType = contentType || '';
    var byteCharacters = base64ToString(base64);
    return stringToBlob(byteCharacters, contentType);
}
exports.base64ToBlob = base64ToBlob;
/**Convierte una cadena binaria en un blob */
function stringToBlob(value, contentType) {
    var sliceSize = 512;
    var byteArrays = [];
    for (var offset = 0; offset < value.length; offset += sliceSize) {
        var slice = value.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
}
exports.stringToBlob = stringToBlob;
/**Convierte un blob a una cadena */
function blobToString(value) {
    var reader = new FileReader();
    return new Promise(function (resolve) {
        reader.onload = function () {
            resolve(reader.result);
        };
        reader.readAsText(value);
    });
}
exports.blobToString = blobToString;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/keautils/dist/base64.js
// module id = 2272
// module chunks = 0